import { createRamModInstances, RamModUI } from './ramModUI';
import Axios from 'axios';
import { Notification } from '../../../notification/notfication';

class RamMod {
    public constructor(private ui: RamModUI) {
        this.ui.onAddRamClick(this.updateRam.bind(this));
        this.ui.onGetMoreRamClick(this.showModal.bind(this));
        this.ui.onDeactivateRamClick(this.deactivateRam.bind(this));
        this.ui.render(this.updatePrice.bind(this));
    }

    public showModal() {
        this.ui.resetModal();
        this.ui.showModal();
    }

    private deactivateRam() {
        this.ui.setUnits(0);
        this.updateRam('.deactivate-mod');
    }

    private updateRam(buttonClass: string = '.changeQuota') {
        this.ui.disableButton(buttonClass);
        Axios.post(window.ramUpdate, this.ui.getFormData(), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(() => {
            window.location.reload();
        }).catch((error) => {
            new Notification('danger', 'Oops.', error.response.data.message);
            if (error.response.data.noBalance === true) {
                // window.initRechargeModal(error.response.data.price);
            }
            this.ui.enableButton(buttonClass);
        });
    }

    private updatePrice(units: number) {
        this.ui.disableButton('.changeQuota');
        Axios.post(window.ramGetPrice + '/' + units, {}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            this.ui.updatePriceInfo(response.data, units);
            this.ui.enableButton('.changeQuota');
        }).catch((error) => {
            new Notification('danger', 'Oops.', error.response.data.message);
            this.ui.enableButton('.changeQuota');
        });
    }
}

export function initRamMod() {
    return createRamModInstances().map((ui: RamModUI) => {
        return new RamMod(ui);
    })
}
